<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }" >
    <nav class="navbar navbar-light bg-lightnav">
      <a class="navbar-brand" href="\">
        <img height="60" src="img/brand/sydneyMetroLogo.png">
      </a>
      <form class="navbar-search navbar-search-light form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <div class="form-group mb-0">
              <base-input placeholder="Search"
                          class="input-group-alternative"
                          alternative=""
                          addon-right-icon="fas fa-search">
              </base-input>
          </div>
      </form>
    </nav>
    <side-bar
      :background-color="sidebarBackground"
      short-title="Sydney Metro"
      title="Sydney Metro"
      class="navbar navbar-light bg-lightnav pt-0"
    >
      <template slot="links" v-for="zone in zones">
        <sidebar-item :link="{name: '', title: zone.title, icon: zone.icon, path: zone.path}"/>

      </template>

      <template slot="links">
        <div style="bottom: 7px !important; position:fixed;">
          <sidebar-item :link="{name: '', title: 'Contact Us', icon: 'img/icons/projectIcon/contact_icon.png', path: '/'}"/>
        </div>
      </template>

    </side-bar>




    <div class="main-content row" :data="sidebarBackground">
      <div class="col-2 pl-0 pr-0" >
        <!-- style="background-color: #d9d9d9;" -->
      <!-- <div class="col-2 pl-0 pr-0" style="background-color: #404952;"> -->
        <!-- <select class="custom-select" name="" v-model="selectedLine" :disabled="lines.length>0?false:true">
          <option value="0" selected disabled>Select Line</option>
          <option v-for="(item, index) in lines" :key="index" :value="item.code">{{item.title}}</option>
        </select> -->
        <!-- <base-button
          size="sm"
          type="dark"
          icon="ni ni-curved-next"
        >
        </base-button> -->
        <dashboard-navbar :menu="computedMenu" :sideBarTitle="computedSideBarTitle"></dashboard-navbar>
      </div>
      <div class="col-10">
        <!-- Content -->
          <tabs fill info type="info" tabNavClasses="tabList col-12" tabContentClasses="" activeTab="insightSection">
            <card shadow bodyClasses="frameContainerClass">

              <div v-for="(item, itemIndex) in currentSelectedProjectTab">
                  <tabPane :key="itemIndex" :title="item.title.toUpperCase()" :id="item.title.toLowerCase()+'Section'">
                    <div class="description">
                      <template v-if="item.url">
                        <!-- <template v-if="item.title == 'PROJECT MANAGEMENT'"> -->
                          <vue-friendly-iframe  :src="item.url" className="myFrame" allow="*"></vue-friendly-iframe>
                        <!-- </template>
                        <template v-else>
                          <img :src="item.url" alt="" class="myFrame">
                        </template> -->
                        <!-- <img src="img/assets/tabs/InsightTab2.png" alt="" class="myFrame"> -->

                        <!-- <vue-friendly-iframe v-if="activeTabFlags[item.title.toLowerCase()+'Section']" :src="item.url" className="myFrame" allow="*"></vue-friendly-iframe> -->
                      </template>
                      <template v-else>
                        <img :src="item.imgUrl" alt="" class="myFrame">
                      </template>
                    </div>
                  </tabPane>

              </div>
              <!-- <tabPane key="8" title="TEST">
                <div class="description">
                  <vue-friendly-iframe  src="https://custom-wab-app.geodemosolutions.com/" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane> -->
              <!-- <tabPane :key="flagIndex" :title="">
                <div class="description">
                  <vue-friendly-iframe v-if="" :src="" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane> -->

              <!-- <tabPane title="INSIGHT" id="insightSection">
                <div class="description">
                  <vue-friendly-iframe v-if="activeTabFlags.insightSection" src="https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane> -->
              <!-- <tabPane title="BIM 360" id="bim360Section">
                <div class="description">
                  <img src="img/assets/BIM_360_Document_Management.png" alt="" class="myFrame"> -->
                  <!-- do not remove the IFRAME below, as we'll replace this with the proper link on prod -->
                  <!-- <vue-friendly-iframe v-if="activeTabFlags.bim360Section" src="https://docs.b360.autodesk.com/projects/3f5bc2e8-a49b-4dda-a2be-9cd7018286fb/folders/urn:adsk.wipprod:fs.folder:co.6qt7XpECQLuyyPmcVZzDLQ/detail" className="myFrame" allow="*"></vue-friendly-iframe> -->
                <!-- </div>
              </tabPane> -->
              <!-- <tabPane title="GIS DASHBOARD" id="GISDashboardSection">
                <div class="description">
                  <vue-friendly-iframe v-if="activeTabFlags.GISDashboardSection" src="https://arcg.is/az5CK" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane>
              <tabPane title="GIS PORTAL" id="GISPortalSection">
                <div class="description">
                  <vue-friendly-iframe v-if="activeTabFlags.GISPortalSection" src="https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=fbfd4ce51d534a7486b30f2d7ee6326c" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane>
              <tabPane title="SIMULATION" id="simulationSection">
                <div class="description">
                  <video autoplay loop controls src="https://arcadiso365-my.sharepoint.com/personal/mitch_medway_hyderconsulting_com/Documents/Microsoft%20Teams%20Chat%20Files/Mobility%20Simulation%20Test.mp4" class="myFrame" allow="*"></video>
                </div>
              </tabPane>
              <tabPane title="OPS" id="opsSection">
                <div class="description">
                  <vue-friendly-iframe v-if="activeTabFlags.opsSection" src="https://arcadisaapmetropoc.azurewebsites.net/" className="myFrame" allow="*"></vue-friendly-iframe>
                </div>
              </tabPane>
              <tabPane title="TEAM BINDER" id="teamBinderSection" class="disabled">
                <div class="description">
                </div>
              </tabPane> -->
            </card>
          </tabs>
        <!-- router purposes -->
        <div @click="toggleSidebar">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import ContentHeader from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import tabs from '../components/Tabs/Tabs.vue';
  import tabPane from  '../components/Tabs/TabPane.vue';

  export default {
    name: "DashboardLayout",
    components: {
      DashboardNavbar,
      ContentHeader,
      ContentFooter,
      FadeTransition,
      tabs,
      tabPane
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
        collapsed: false,
        selectedTheme: '',
        selectedLine: "0"
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    },
    computed: {
      lines: {
        get() {
          return this.$store.state.sideBarStore.lines
        }
      },
      counter: {
        // do not remove, template for computed code
        get() {
          return this.$store.state.sideBarStore.counter
        }
      },
      zones: {
        get() {
          return this.$store.state.sideBarStore.zones
        }
      },
      computedSideBarTitle: {
        get() {
          // return this.$store.state.sideBarStore.selectedLine.title
          return this.$store.state.sideBarStore.selectedPortfolio.title
        }
      },
      activeTabFlags: {
        get() {
          return this.$store.state.sideBarStore.activeTabFlags
        }
      },
      currentSelectedProjectTab: {
        get() {
          return this.$store.state.sideBarStore.currentSelectedProjectTab.tabs
        }
      },
      computedMenu: {
        get() {
          const current = this
          let headerTitle = current.$store.state.sideBarStore.selectedLine.title
          var href = current.$store.state.sideBarStore.selectedZone.path
          var currentCategory = current.$store.state.sideBarStore.currentSelectedProjectTab.category
          var constructedMenu = []
          // let titleObject = {
          //   header: false,
          //   title: headerTitle,
          //   class: 'headerElementStyle'
          // }
          // constructedMenu.push(titleObject)
          // current.$store.state.sideBarStore.selectedStations.forEach((station, stationIndex)=>{
          //   let elementObject = {
          //     href: "",
          //     title: station,
          //     child: [],
          //     class: "parentElementStyle"
          //   }
          //   current.$store.state.sideBarStore.selectedCategories.forEach((category, categoryIndex)=>{
          //     let childObject = {
          //       href: "/test",
          //       title: category,
          //       external: true,
          //       class: 'childElementStyle'
          //     }
          //     elementObject.child.push(childObject)
          //   })
          //   constructedMenu.push(elementObject)
          // })
          current.$store.state.sideBarStore.selectedProjects.forEach((project, projectIndex)=>{
            let elementObject = {
              href: "",
              title: project,
              child: [],
              class: "parentElementStyle"
            }
            current.$store.state.sideBarStore.selectedCategories.forEach((category, categoryIndex)=>{
              var classValue = 'childElementStyle'
              if(currentCategory == category){
                classValue = 'childElementStyle text-active-color'
              }
              let childObject = {
                href: "/test",
                title: category,
                external: true,
                class: classValue
              }
              elementObject.child.push(childObject)
            })
            constructedMenu.push(elementObject)
          })
          return constructedMenu
        }
      }
    },
    watch: {
      counter: function() {
        // do not remove, template for watch code
        console.log(this.counter);
      },
      selectedLine: function(){
        const current = this
        console.log(current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedLine",current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedStations",current.selectedLine);
        // current.$store.dispatch("sideBarStore/setSelectedLine",current.selectedLine);

      }
    },
  };
</script>
<style>
.navbar-vertical.navbar-expand-md {
  /* position: relative !important;
  height: 90.6vh;
  max-width: 110px !important; */
  max-width: 110px !important;
  top: inherit !important;
  height: 100% !important;
  bottom: unset !important;
  /* z-index: -1; */
}
.childElementStyle {
  color: #fff!important;
  font-weight: bold!important;
}
.parentElementStyle {
  font-weight: bold!important;
}
.headerElementStyle {
  font-weight: bolder!important;
  font-size: 20px!important;
}
.myFrame {
  width: 1465px!important;
  /* width: 100% !important; */
  /* height: 763px!important; */
  height: 82vh!important;
  /* border: none; */
}
.frameContainerClass {
  padding:3px!important;
  border-radius: 2pt;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  /*border-color: #404952;
  border-style: solid;*/
}

</style>
